











import Vue from 'vue';
export default Vue.extend({
    props: {
        forId: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        strong: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        requiredText() {
            if (this.required) {
                return ` (${this.$t('required')})`;
            } else {
                return '';
            }
        },
    },
});
